import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/lib/auth";

const navItems = [
  { to: "/", label: "Inicio" },
  { to: "/catalogo", label: "Catálogo" },
  { to: "/contacto", label: "Contacto" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b-2 border-slate-950">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="logo-home-link"
        >
          <img
            src="/assets/45529113931edd83.png"
            alt="Great Wall Machinery"
            className="h-10 md:h-12 w-auto group-hover:scale-105 transition-transform"
          />
          <div className="flex flex-col leading-tight border-l-2 border-slate-200 pl-3">
            <span className="font-display font-black text-slate-950 text-sm md:text-base uppercase tracking-tight">
              Great Wall
            </span>
            <span className="font-mono text-[10px] md:text-[11px] text-slate-500 uppercase tracking-wider">
              Machinery LATAM
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 font-display font-semibold uppercase tracking-wide text-sm transition-colors ${
                  isActive
                    ? "text-slate-950 border-b-2 border-amber-500"
                    : "text-slate-600 hover:text-slate-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user?.is_editor ? (
            <>
              <button
                onClick={() => navigate("/dashboard")}
                data-testid="header-dashboard-btn"
                className="flex items-center gap-2 px-4 py-2 bg-slate-950 text-white font-display font-bold uppercase text-xs tracking-wider hover:bg-slate-800 transition-colors"
              >
                <ShieldCheck className="w-4 h-4" />
                Panel
              </button>
              <button
                onClick={async () => { await logout(); navigate("/"); }}
                data-testid="header-logout-btn"
                className="px-3 py-2 text-xs font-display font-semibold uppercase tracking-wider text-slate-600 hover:text-slate-950"
              >
                Salir
              </button>
            </>
          ) : (
            <Link
              to="/contacto"
              data-testid="header-cotizar-btn"
              className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-display font-black uppercase tracking-wider px-5 py-3 text-sm btn-brutal"
            >
              Cotizar
            </Link>
          )}
        </div>

        <button
          className="md:hidden p-2 border-2 border-slate-950"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-slate-950 bg-white">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-6 py-4 font-display font-semibold uppercase tracking-wide text-sm border-b border-slate-200 ${
                    isActive ? "text-amber-600 bg-slate-50" : "text-slate-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            {user?.is_editor && (
              <button
                onClick={() => { setOpen(false); navigate("/dashboard"); }}
                data-testid="mobile-nav-dashboard"
                className="px-6 py-4 text-left font-display font-semibold uppercase tracking-wide text-sm text-slate-950 bg-amber-50 border-b border-slate-200"
              >
                Panel administración
              </button>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
